<template>
    <span>{{statusTitle}}</span>
</template>

<script>
    import {dispatchRequestStatus} from "../helpers/dispatch";
    export default {
        name: 'dispatch-request-status',

        props: {
            status: {required: true},
        },

        computed: {
            statusTitle() {
                // if (!this.status) this.status = 'unknown'
                return dispatchRequestStatus(this.status)
            }
        }
    }
</script>
